import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import VueAxios from "vue-axios";
import Notifications from "vue-notifyjs";
import VeeValidate from "vee-validate";
import VueTabs from "vue-nav-tabs";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// library auto imports
import "es6-promise/auto";

import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-nav-tabs/themes/vue-tabs.scss";
import "vue-notifyjs/themes/default.scss";

import packageJson from "../package.json";

import App from "./App.vue";
import router from "./routes/router";

import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/SidebarPlugin";

// Notifications plugin. Used on Notifications page
// asset imports
import "./assets/sass/light-bootstrap-dashboard.scss";
import "./assets/beast.scss";

locale.use(lang);
library.add(fas);

/* eslint-disable no-undef */
Vue.config.productionTip = process.env.NODE_ENV === "development";
const beast = {
  host: BEAST_HOST || process.env.VUE_APP_BEAST_HOST,
  api: BEAST_API || process.env.VUE_APP_BEAST_API,
  version: packageJson.version,
  build: BEAST_BUILD_REVISION !== "" ? `${BEAST_BUILD_REVISION}` : ""
};
Vue.prototype.$beast = beast;
axios.defaults.baseURL = `${beast.host}${beast.api}`;

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueAxios, axios);
Vue.router = router;

Vue.use(require("@websanova/vue-auth"), {
  auth: {
    request(req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: `Bearer ${token}` });
    },

    response(res) {
      let { token } = res.data;
      if (!token) {
        token = this.options.http._getHeaders.call(this, res).Authorization;
      }

      if (token) {
        token = token.split(/Bearer:?\s?/i);
        return token[token.length > 1 ? 1 : 0].trim();
      }

      return null;
    }
  },
  http: require("@websanova/vue-auth/drivers/http/axios.1.x"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x"),
  authRedirect: "/auth/login",
  logoutData: { url: "admin/logout", makeRequest: true },
  loginData: { url: "admin/login" },
  fetchData: { url: "admin/user" },
  refreshData: { url: "admin/refresh" },
  parseUserData: (data) => {
    sessionStorage.setItem("user", JSON.stringify(data));
    return data;
  }
});

Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(SideBar);
Vue.use(Notifications, {
  type: "primary",
  timeout: 2000,
  horizontalAlign: "center",
  verticalAlign: "top"
});
Vue.use(VueTabs);
Vue.use(VeeValidate);

new Vue({
  router,
  render: h => h(App),
}).$mount("#app");
